import React, { useEffect, useState } from "react";
import { useInvoiceListContext } from "../context";
import InvoiceListTable from "../InvoiceListTable";
import { useQuery } from "@tanstack/react-query";
import { getInvoices } from "../../../../../api/services/default/invoices";

export default function AllInvoices({
  isEmployeeInvoices,
  employeeID,
  isClientInvoices,
  clientID,
}) {
  const { state } = useInvoiceListContext();

  const { data, isLoading } = useQuery({
    queryKey: ["getInvoices", "all", { clientID, employeeID }],
    queryFn: () => getInvoices("all", clientID, employeeID)
  })

  return (
    <InvoiceListTable
      condition={state.tabValue}
      isEmployeeInvoices={false}
      employeeID={employeeID}
      clientID=""
      type="all"
      isClientInvoices={false}
      invoicesList={data}
      isLoading={isLoading}
    />
  );
}
